import React from 'react';
import classNames from 'classnames';
import Modal from '../modal/modal.component';
import styles from './popup.module.scss';
import { PopupInterface } from './popup.interface';
import { CloseIcon } from '../../icons';

const Popup: React.FunctionComponent<PopupInterface> = ({
  isOpened,
  onClose,
  children,
  footer,
  className,
}) => {
  return (
    <React.Fragment>
      <article className={styles.indexing}>
        {children}
        {footer}
      </article>

      {isOpened && (
        <Modal onClose={onClose}>
          <article
            className={classNames(
              styles.component,
              className,
            )}
          >
            <CloseIcon
              className={styles.close}
              onClick={onClose}
            />

            <div className={styles.content}>
              {children}
            </div>

            {footer}
          </article>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default Popup;
